import { createStyles } from '@mantine/core';
import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';

import {
  LeaguePageHeader,
  type LeaguePageHeaderItem,
} from '~/domains/common/components/AppShellHeader/components/LeaguePageHeader/LeaguePageHeader';
import { Routes } from '~/domains/common/constants/routes';
import { useRoutePrefetch } from '~/common/hooks/useRoutePrefetch';

import { useSubCategories } from '../../state/selectors/discover.selectors';
import { useSubCategoriesLoading } from '../../state/selectors/ui.selectors';
import { getMarketTypeFromQuery } from '../../utils/marketGroupType';

const useStyles = createStyles((theme) => ({
  mobileOnly: {
    [theme.fn.largerThan('xl')]: {
      display: 'none',
    },
  },
}));

export function MarketsLeaguePageHeader() {
  const router = useRouter();
  const { classes } = useStyles();
  const subCategories = useSubCategories();
  const isLoading = useSubCategoriesLoading();
  const marketType = getMarketTypeFromQuery(router.query.type);

  const items = useMemo<LeaguePageHeaderItem[]>(
    () =>
      subCategories.map((subcategory) => ({
        id: subcategory.id,
        label: subcategory.name,
        iconUrl: subcategory.iconUrl,
        disabled: !subcategory.active,
      })),
    [subCategories]
  );

  const activeSport = (router.query.sport as string | undefined)?.toLowerCase();

  const leagueRoutes = useMemo(
    () =>
      items
        .filter((item) => !item.disabled)
        .map((item) => Routes.marketsSport(item.id, marketType)),
    [items, marketType]
  );

  useRoutePrefetch(leagueRoutes);

  const handleSelectLeague = useCallback(
    (item: LeaguePageHeaderItem) => {
      if (item.disabled) return;

      router.push(Routes.marketsSport(item.id, marketType));
    },
    [marketType, router]
  );

  return (
    <div className={classes.mobileOnly}>
      <LeaguePageHeader
        backHref={Routes.markets()}
        items={items}
        activeItemId={activeSport}
        onSelectItem={handleSelectLeague}
        isLoading={isLoading}
      />
    </div>
  );
}
